<template>
  <div class="day-data">
    <!-- 时间 -->
    <div class="time-choice" @click="calendar_show = true">
      <span>{{date}}</span>
      <img :src="IconMenu" />
    </div>
    <!-- item列表 -->
    <div class="data-item" v-for="(item, index) in list" :key="index">
      <div class="time">
        <span>取水时间</span>
        <span>{{item.time}}</span>
      </div>
      <div class="data-list">
        <img :src="IconCup" class="cup-icon" />
        <div class="number-text">取水量 <span class="wechatNumber">{{item.amount}}</span><span>ml</span></div>
        <img :src="IconDrop" class="drop-icon" />
        <div class="number-text">水质TDS <span class="wechatNumber">{{item.tds}}</span></div>
      </div>
    </div>
    <!-- 查看更多 -->
    <Btn title="查看更多" @clickBtn="NextPage" type="light" width="4.4rem" v-show="page * 1 !== total_pages * 1" />
    <!-- 日历 -->
    <van-popup v-model="calendar_show" position="bottom">
      <!-- <div class="tool-bar">
        <div class="btn" @click="calendar_show = false">取消</div>
        <div class="btn" @click="calendar_show = false">确认</div>
      </div> -->
      <Calendar class="calendar-box" @choseDay="choseDay" />
    </van-popup>
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  import Calendar from 'vue-calendar-component'
  export default {
    data () {
      return {
        calendar_show: false,
        list: [],
        page: 1,
        total_items: 0,
        total_pages: 0,
        date: this.$Tool.FormatTime(new Date(), 'YYYY-MM-DD')
      }
    },
    methods: {
      choseDay (e) {
        this.date = this.$Tool.FormatTime(e, 'YYYY-MM-DD')
        this.calendar_show = false
        this.RefreshList()
      },
      GetList () {
        this.$Get('Common.WaterGetDay', {
          cup_id: this.$route.query.id,
          date: this.date,
          page: this.page,
          limit: 5
        }).then(res => {
          this.total_pages = res.data.total_pages
          this.total_items = res.data.total_items
          if (this.page === 1) {
            this.list = res.data.items
          } else {
            this.list = [...this.list, ...res.data.items]
          }
        })
      },
      RefreshList () {
        this.page = 1
        this.total_pages = 0
        this.list = []
        this.GetList()
      },
      NextPage () {
        this.page += 1
        this.GetList()
      }
    },
    mounted () {
      this.GetList()
    },
    computed: {
      ...SetImage(['IconDrop', 'IconCup', 'IconMenu'])
    },
    components: {
      Calendar
    }
  }
</script>

<style lang="less" scoped>
  .day-data {
    .p(.5rem .24rem);
    .tool-bar {
      .h(.9rem);
      .c(#fff);
      .fz(.28rem);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bg(#00b0f4);
      position: relative;
      .p(0 .4rem);
    }
    .calendar-box /deep/ .wh_content_all {
      .bg(#00b0f4);
      .wh_isToday {
        .bg(#fff);
        .c(#333);
      }
    }
    & /deep/ .button-style {
      .m(.6rem auto 0);
    }
    .time-choice {
      .w(4.44rem);
      .h(.7rem);
      .br(.1rem);
      .bg(#f4f4f4);
      .m(0 auto .47rem);
      .flex-cc();
      .fz(.26rem);
      .c(#333);
      img {
        .w(.2rem);
        .h(.12rem);
        .ml(.37rem);
      }
    }
    .data-item {
      .br(.1rem);
      .bg(#f1fbff);
      .p(.24rem);
      & + .data-item {
        .mt(.22rem);
      }
      .time {
        .fz(.26rem);
        .c(#999);
        .mb(.25rem);
        span + span {
          .c(#333);
          .ml(.19rem);
        }
      }
      .data-list {
        .flex-c();
        .cup-icon {
          .w(.3rem);
          .h(.3rem);
          .mr(.06rem);
        }
        .drop-icon {
          .w(.23rem);
          .h(.31rem);
          .mr(.06rem);
        }
        .number-text {
          .fz(.24rem);
          .w(2.16rem);
          .c(#999);
          span {
            .c(#333);
            .fz(.3rem);
            & + span {
              .fz(.24rem);
            }
          }
        }
      }
    }
  }
</style>
